var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teacher"},[_c('list-template',{attrs:{"loading":_vm.loading,"total":_vm.total,"table-data":_vm.tableData,"table-config":_vm.tableConfig,"current-page":_vm.page,"hasAdd":""},on:{"onChangePage":_vm.changeCurrentPage,"onHandle":_vm.tableHandle,"onAdd":_vm.onAdd}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }